const auth = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

export { auth };
